import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';

import { ConfigDetail, configRegistryKeys } from './useConfigsQuery';

/**
 * Loads one config with its value and schema.
 *
 * Kept separate from the list so the list can stay payload-free: a value may be
 * a large document, and TM_CREDENTIALS is a secret that has no business being in
 * a response the page fetches on every keystroke of the search box.
 */
export const useConfigQuery = (key: string | null) => {
  const { sessionState } = useAuth();
  const isReady = isSignedIn(sessionState);

  return useQuery({
    queryKey: configRegistryKeys.detail(key ?? ''),
    queryFn: async () => {
      const { data } = await get<ConfigDetail>(
        `/v1.0/internals/configs/${encodeURIComponent(key as string)}`,
      );
      return data;
    },
    enabled: isReady && !!key,
  });
};

export default useConfigQuery;
